module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toctitle"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("Introduction: Watch Out, Superstar")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_vm._v("Chapter 1: Admit It, Your Life Doesn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Feel")]), _vm._v(" as Good as It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Looks")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: You Don’t Know What You Don’t Know")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The World May Be Friendlier Than You Think")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Don’t Always Believe What You Think")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: You’re "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not")]), _vm._v(" Playing to Win")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Detox Your Mindset")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Find Your Purpose")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: To "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Really")]), _vm._v(" Live on Purpose, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Really")]), _vm._v(" Stop Lying")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Accept Yourself, Liberate Yourself")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Break Up with Anger")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Pray for a Sh*tstorm")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Step into Your Authentic Power")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: From Restless Swan to Wild Goose")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_About",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 75
// module chunks = 0